import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { message, Button } from 'antd';
// 家长学前须知改用 createPortal 自绘，不再用 Ant Design Modal
import './index.scss';
import back from 'asset/img/back.png';
import unstep from 'asset/img/unstep.png';
import step from 'asset/img/step.png';
import VerticalSlider from './VerticalSlider/VerticalSlider';
import { useNavigate } from 'react-router-dom';
import openLiwuMusic from 'asset/music/openLiwu.mp3';
import WkModal from 'components/Modal'
import music from 'asset/img/laba.png';
import menu1_avator from 'asset/img/menu1_avator.webp';
import menu2_avator from 'asset/img/menu2_avator.webp';
import menu3_avator from 'asset/img/menu3_avator.webp';
import musicClose from 'asset/img/laba-close.png';
import star from 'asset/img/star.png';
import unopenLiwu from 'asset/img/unopenLiwu.webp';
import openLiwu from 'asset/img/openLiwu.webp';
import unstar from 'asset/img/unstar.png';
import { useLocation } from 'react-router-dom';
import { getCourseSerial, getStudyRecord, getStorRewadRecord, studyDoneReward, getUserInfo, getGardenInfo } from 'network';
import { useDispatch } from 'react-redux';
import { setUser as setUserAction } from 'actions';
import { calcSerial, serialName } from 'utils';
import { OssOther, agent, canAccessAllLevels } from 'utils/const.js';
import { getPetAvatarSrc } from '../Pet/petPhaseConfig';
import { savePetInfoToStorage } from 'utils/petStorage';
import { checkWebpSupport, isWebpSupported } from 'utils/webpSupport';
import { getTreasureBoxCoin, getBigBoxCoin } from 'utils/reward';
import { rollTreasureFood } from 'constants/treasureFoods';
import Loadding from 'components/Loadding'
import TreasureBoxModal from 'components/TreasureBoxModal'
import Fireworks from 'components/Fireworks'
import { playTreasureBoxOpenSound } from 'utils/soundEffect';
import tipsAudioSrc from 'asset/video/tips.MP3';
import tips2AudioSrc from 'asset/video/tips2.mp3'; // 影视读经小士家长学前须知语音
import silme from 'asset/img/silme.png';

// 关卡上限：历史版本为 500 关
const MAX_LEVEL = 500;

// 家长学前须知（Home）：全局只弹一次，看过后 Home 入口不再弹
const PARENT_PRE_NOTICE_SEEN_KEY = 'parent_pre_notice_seen';
const hasSeenParentPreNotice = () => {
    try { return localStorage.getItem(PARENT_PRE_NOTICE_SEEN_KEY) === '1'; } catch (e) { return true; }
};
const setParentPreNoticeSeen = () => {
    try { localStorage.setItem(PARENT_PRE_NOTICE_SEEN_KEY, '1'); } catch (e) {}
};

// 读经小士(985)家长学前须知：与 Home 独立，单独缓存，内容单独（待替换）
const PARENT_PRE_NOTICE_YINGSHI_DUJING_SEEN_KEY = 'parent_pre_notice_yingshi_dujing_seen';
const hasSeenYingshiDujingPreNotice = () => {
    try { return localStorage.getItem(PARENT_PRE_NOTICE_YINGSHI_DUJING_SEEN_KEY) === '1'; } catch (e) { return true; }
};
const setYingshiDujingPreNoticeSeen = () => {
    try { localStorage.setItem(PARENT_PRE_NOTICE_YINGSHI_DUJING_SEEN_KEY, '1'); } catch (e) {}
};

// 读经小士(985)写死：仅开放前5关，第6关起需班主任解锁
const DUJING_XIAOSHI_SERIAL = 985; // 读经小士(小雷音寺)，用于家长须知

const DAILY_LEVEL_LIMIT_KEY = 'limit-data-global-v2';
const DAILY_LEVEL_LIMIT = 30;
const LEGACY_LIMIT_KEY = 'limit-data';
const LEGACY_YINGSHI_LIMIT_KEY = 'limit-data-yingshi';
const DAILY_LEVEL_LIMIT_MESSAGE = (
    <div style={{textAlign: 'center'}}>请爱护眼睛哦，每天最多闯30个新关卡，<br/>旧关卡可以无限玩哦~</div>
);

const getTodayKey = () => new Date().toISOString().split('T')[0];

const readLimitStorage = (key) => {
    const raw = localStorage.getItem(key);
    if (!raw) return { count: 0, lastDate: '' };
    try {
        const data = JSON.parse(raw);
        return { count: Number(data?.count) || 0, lastDate: data?.lastDate || '' };
    } catch {
        return { count: 0, lastDate: '' };
    }
};

const getDailyLevelLimitData = () => {
    const today = getTodayKey();
    const current = readLimitStorage(DAILY_LEVEL_LIMIT_KEY);
    if (current.lastDate === today) return current;

    const legacy = readLimitStorage(LEGACY_LIMIT_KEY);
    const legacyYingshi = readLimitStorage(LEGACY_YINGSHI_LIMIT_KEY);
    const migratedCount = Math.max(
        legacy.lastDate === today ? Number(legacy.count) || 0 : 0,
        legacyYingshi.lastDate === today ? Number(legacyYingshi.count) || 0 : 0
    );
    return { count: migratedCount, lastDate: today };
};

const saveDailyLevelLimitData = (data) => {
    localStorage.setItem(DAILY_LEVEL_LIMIT_KEY, JSON.stringify(data));
};

// 影视 serial_id -> slide 索引：985-988 第1页，989-991/995 第2页，992-994 第3页
const getYingshiSlideIndex = (serialId) => {
    const sid = Number(serialId);
    if ((sid >= 989 && sid <= 991) || sid === 995) return 1;
    if (sid >= 992 && sid <= 994) return 2;
    return 0; // 985-988 及默认
};

// 背景图路径映射 - 按需动态加载（带 webp 降级）
const backgroundPathsWebp = {
    '0-0': () => import('asset/img/bk-menu-01-01.webp'),
    '0-1': () => import('asset/img/bk_detail_01_01.webp'),
    '0-2': () => import('asset/img/bk_detail_01_02.webp'),
    '0-3': () => import('asset/img/bk-menu-01-04.webp'),
    '1-0': () => import('asset/img/bk_detail_02_01.webp'),
    '1-1': () => import('asset/img/bk-menu-02-01.webp'),
    '1-2': () => import('asset/img/bk_detail_02_02.webp'),
    '1-3': () => import('asset/img/bk_detail_02_01.webp'),
    '2-0': () => import('asset/img/bk-menu-03-01.webp'),
    '2-1': () => import('asset/img/bk_detail_03_01.webp'),
    '2-2': () => import('asset/img/bk_detail_03_02.webp'),
    '2-3': () => import('asset/img/bk-menu-03-03.webp'),
};

// PNG 降级路径
const backgroundPathsPng = {
    '0-0': () => import('asset/img/bk-menu-01-01.png'),
    '0-1': () => import('asset/img/bk_detail_01_01.png'),
    '0-2': () => import('asset/img/bk_detail_01_02.png'),
    '0-3': () => import('asset/img/bk-menu-01-04.png'),
    '1-0': () => import('asset/img/bk_detail_02_01.png'),
    '1-1': () => import('asset/img/bk-menu-02-01.png'),
    '1-2': () => import('asset/img/bk_detail_02_02.png'),
    '1-3': () => import('asset/img/bk_detail_02_01.png'),
    '2-0': () => import('asset/img/bk-menu-03-01.png'),
    '2-1': () => import('asset/img/bk_detail_03_01.png'),
    '2-2': () => import('asset/img/bk_detail_03_02.png'),
    '2-3': () => import('asset/img/bk-menu-03-03.png'),
};

// 虚拟列表：根据关卡索引计算 margin-left（替代 nth-child 选择器）
// 基于设计稿宽度 440px 的原始值
const MARGIN_LEFT_BASE = {
    1: 250,  // 8n+1
    2: 77,   // 8n+2
    3: 267,  // 8n+3
    4: 66,   // 8n+4
    5: 210,  // 8n+5
    6: 69,   // 8n+6
    7: 277,  // 8n+7
    0: 100,  // 8n+8 (8n+0)
};

// 关卡元素宽度
const LEVEL_ITEM_WIDTH = 100;

// 设计稿基准宽度
const DESIGN_WIDTH = 440;

// 路径中心点（在设计稿中的位置）
const PATH_CENTER = (66 + 277 + LEVEL_ITEM_WIDTH) / 2; // ≈ 221.5

// 计算关卡的 left 位置（按屏幕宽度等比例缩放，保持一致的视觉比例）
const getMarginLeft = (displayIndex, screenWidth) => {
    const mod = displayIndex % 8;
    const baseValue = MARGIN_LEFT_BASE[mod === 0 ? 0 : mod];
    
    // 计算缩放比例：屏幕宽度 / 设计稿宽度
    // 这样在任何屏幕上，路径占屏幕的比例都是一致的
    const scale = screenWidth / DESIGN_WIDTH;
    
    // 基础值相对于路径中心的偏移量
    const offsetFromCenter = baseValue - PATH_CENTER;
    
    // 按比例缩放偏移量
    const scaledOffset = offsetFromCenter * scale;
    
    // 最终位置 = 屏幕中心 + 缩放后的偏移
    return screenWidth / 2 + scaledOffset;
};

// 每个关卡的高度（rem）
const ITEM_HEIGHT_REM = 11.9;
// 缓冲区大小（渲染可视区域外的额外元素数量）
const BUFFER_SIZE = 10;

const Menu = () => {
    const [rootFontSize, setRootFontSize] = useState(parseFloat(getComputedStyle(document.documentElement).fontSize));
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const buttonContainerRef = useRef(null);
    const location = useLocation();
    let navigate = useNavigate();
    // 当前关卡（已解锁最高关）
    const [count, setCount] = useState(MAX_LEVEL);
    const [coin, setCoin] = useState(500);
    const [boxFood, setBoxFood] = useState(null); // 宝箱 30% 概率开出的食物
    const [boxVisible, setBoxVisible] = useState(false);
    const [avatarStatus, setAvatarStatus] = useState(false);
    // 总关卡
    const [total, setToal] = useState(MAX_LEVEL);
    const [user, setUser] = useState({});
    const [pet, setPet] = useState({}); // P0优化：宠物信息
    const [musk, setMusk] = useState(true);
    const [recordList, setRecordList] = useState([]);
    const [rewordList, setRewordList] = useState([]);
    const [isOpeBig, setIsOpeBig] = useState(false);
    const [progress, setProgress] = useState(0);
    const [id, setId] = useState('');
    const [random, setRandom] = useState(0.1);
    // 页面类型
    const [scores, setScores] = useState([]);
    const searchParams = new URLSearchParams(location.search);
    const type = searchParams.get('type');
    const vip = searchParams.get('vip');
    const index = searchParams.get('index');
    const fromYingshi = searchParams.get('from') === 'yingshi';
    const yingshiSerialId = searchParams.get('serial_id');
    const yingshiSlide = searchParams.get('slide');
    // 影视入口用 serial_id，Home 用 type+index 算 serial
    const currentSerialId = fromYingshi && yingshiSerialId ? Number(yingshiSerialId) : calcSerial(type, index);
    // demo 彩蛋模式：菜单样式沿用读经小士(985)背景，但关卡内容读取指定 serial（如 222）
    const demoMode = searchParams.get('demo') === '1';
    const demoContentSerialId = demoMode
        ? Number(searchParams.get('demo_serial_id') || yingshiSerialId || currentSerialId)
        : null;
    const demoMenuSerialId = demoMode
        ? Number(searchParams.get('demo_menu_serial_id') || currentSerialId)
        : null;
    const [Isback, setIsback] = useState(false);
    const [targetScrollTop, setTargetScrollTop] = useState(0);
    const [musicStatus, setMusicStatus] = useState(true);
    //const audioRef = useRef(null);
    const audioOpenLiwuMusic = useRef(null);
    
    // 家长学前须知弹窗（Home）：无闯关记录时点击第一关先展示
    const [parentPreNoticeVisible, setParentPreNoticeVisible] = useState(false);
    const [parentPreNoticeTargetLevel, setParentPreNoticeTargetLevel] = useState(1);
    const [parentPreNoticeBtnEnabled, setParentPreNoticeBtnEnabled] = useState(false);
    const [parentPreNoticeCountdown, setParentPreNoticeCountdown] = useState(0); // 14 秒倒计时，0 时不展示
    const parentPreNoticeAudioRef = useRef(null);
    const parentPreNoticeTickRef = useRef(null);
    // 读经小士(985)家长学前须知：独立模块，单独缓存与内容（内容待替换）
    const [yingshiDujingPreNoticeVisible, setYingshiDujingPreNoticeVisible] = useState(false);
    const [yingshiDujingPreNoticeBtnEnabled, setYingshiDujingPreNoticeBtnEnabled] = useState(false);
    const [yingshiDujingPreNoticeCountdown, setYingshiDujingPreNoticeCountdown] = useState(0);
    const yingshiDujingPreNoticeAudioRef = useRef(null);
    const yingshiDujingPreNoticeTickRef = useRef(null);

    // 虚拟列表状态
    const [scrollTop, setScrollTop] = useState(0);
    const [containerHeight, setContainerHeight] = useState(window.innerHeight);
    
    // 滚动条拖动状态
    const [isDragging, setIsDragging] = useState(false);
    const scrollbarRef = useRef(null);
    const thumbRef = useRef(null);

    const gotoDetail = (level) => {
        if (demoMode) {
            const DEMO_MAX_LEVEL = 3; // demo 只展示前三关
            if (level > DEMO_MAX_LEVEL) return message.info('演示关卡仅开放前三关');
            const contentSid = demoContentSerialId || currentSerialId;
            const menuSid = demoMenuSerialId || currentSerialId;
            const detailQuery = `from=yingshi&serial_id=${contentSid}&level=${level}&maxLevel=${DEMO_MAX_LEVEL}&boxOpened=0&demo=1&demo_serial_id=${contentSid}&demo_menu_serial_id=${menuSid}`;
            navigate(`/detail?${detailQuery}`);
            return;
        }
        if (level > MAX_LEVEL) {
            return message.info(`当前仅开放前${MAX_LEVEL}关卡`);
        }
        const hasAllLevelAccess = canAccessAllLevels(user);
        if (level > count && !hasAllLevelAccess) {
            return message.info('请先通过之前的关卡');
        }
        // 读经小士(985)第一关：独立家长学前须知，未看过则弹窗（与 Home 共用逻辑分离）
        if (fromYingshi && Number(currentSerialId) === DUJING_XIAOSHI_SERIAL && level === 1 && !hasSeenYingshiDujingPreNotice()) {
            setYingshiDujingPreNoticeBtnEnabled(false);
            setYingshiDujingPreNoticeCountdown(9);
            setYingshiDujingPreNoticeVisible(true);
            return;
        }
        // Home 及非读经小士：未看过「家长学前须知」时，第一次点第 1 关先弹窗
        if (!fromYingshi && level === 1 && !hasSeenParentPreNotice()) {
            setParentPreNoticeTargetLevel(level);
            setParentPreNoticeBtnEnabled(false);
            setParentPreNoticeCountdown(14);
            setParentPreNoticeVisible(true);
            return;
        }
        // 检查宝箱是否已打开：如果 rewordList[level - 1] 存在且有 serial_id，说明已领取
        const rewardItem = rewordList[level - 1];
        const isopen = rewardItem && Number(rewardItem.serial_id) === Number(currentSerialId);
        
        // 仅第4关的宝箱前置到第3关（写死），后面还是8、12、16、20、24、28，31关后每6关一次
        const isBoxLevel = level <= 30 ? (level === 3 || (level >= 8 && level % 4 === 0)) : (level % 6 === 0);
        // level <= count：已通过的关卡才能开宝箱；用 < 会导致最后一关的宝箱（如498关）通关后无法点开
        if (isBoxLevel && !isopen && level <= count) {
            const coinVal = getRandomWeightedNumber();
            const food = rollTreasureFood(); // 30% 概率开出食物
            setCoin(coinVal);
            setBoxFood(food);
            let newRewordList = [...rewordList];
            newRewordList[level - 1] = { serial_id: currentSerialId, number: level };
            playTreasureBoxOpenSound();
            if (audioOpenLiwuMusic.current) {
                audioOpenLiwuMusic.current.play().catch(err => {
                    console.log('播放宝箱音效失败:', err);
                });
            }
            setRewordList(newRewordList);
            const payload = { serial_id: currentSerialId, number: level, coin: coinVal, type: 2 };
            if (food?.goods_id) payload.goods_id = food.goods_id;
            studyDoneReward(payload).then(() => {
                // 不依赖后端 serial：拉 type2 两页，合并去重后前端过滤，与首屏逻辑一致
                Promise.all([
                    getStorRewadRecord({ type: 2, page: 1, size: 500 }),
                    getStorRewadRecord({ type: 2, page: 2, size: 500 })
                ]).then(([r1, r2]) => {
                    const list = mergeRewardPages(
                        r1?.data?.reward_list || [],
                        r2?.data?.reward_list || []
                    );
                    const filled = fillArray(list) || [];
                    // 本次打开的宝箱（如第3关）可能后端尚未返回，合并时保留本地已打开状态，避免用户可重复开宝箱
                    setRewordList((prev) => {
                        const next = filled.slice();
                        const sid = currentSerialId;
                        if (prev[level - 1] && Number(prev[level - 1].serial_id) === Number(sid)) {
                            next[level - 1] = prev[level - 1];
                        }
                        return next;
                    });
                });
            });
            return setBoxVisible(true);
        }
        // 鉴权
        if (!handlePermission(level)) return
        
        // 检查宝箱是否已打开（使用上面已声明的 rewardItem）
        const boxOpened = rewardItem && Number(rewardItem.serial_id) === Number(currentSerialId);
        const detailQuery = fromYingshi
            ? `from=yingshi&serial_id=${currentSerialId}&level=${level}&maxLevel=${count}&boxOpened=${boxOpened ? '1' : '0'}`
            : `type=${type}&index=${index}&level=${level}&maxLevel=${count}&boxOpened=${boxOpened ? '1' : '0'}`;
        navigate(`/detail?${detailQuery}`);
    }

    const updateDailyLevelLimit = () => {
        const limitData = getDailyLevelLimitData();
        const hasAllLevelAccess = canAccessAllLevels(user);
        if (limitData.count >= DAILY_LEVEL_LIMIT && user?.vip_expire !== 111 && !hasAllLevelAccess) {
            message.info(DAILY_LEVEL_LIMIT_MESSAGE);
            return false;
        }
        saveDailyLevelLimitData(limitData);
        return true;
    };
    // 权限校验
    const handlePermission = (level) => {
        const hasAllLevelAccess = canAccessAllLevels(user);
        if (hasAllLevelAccess) return true;
        // 目前关数上限、111为测试号
        // if (level > 200 && user?.vip_expire !== 111) {
        //     message.info('后续关卡正在维护中，敬请期待');
        //     return false
        // }

        const isNewLevel = level === count;
        if (isNewLevel && !updateDailyLevelLimit()) return false;

        // 永久会员和内部账号
        if (user?.vip_expire == 0 || user?.vip_expire == 111 || user?.vip_expire == 222) return true
        
        // vip_expire == 1 表示非会员（因为unsigned不能存储-1，所以用1表示）
        if (user?.vip_expire == 1) {
            message.info('完整学习体验需要会员权限支持哦！');
            return false;
        }
        
        // 其他值（> 0 且不等于 111/222）表示有效期会员，需要判断是否过期
        if (user?.vip_expire > 0 && user?.vip_expire != 111 && user?.vip_expire != 222) {
            // 会员已过期
            if (user?.is_expire) {
                message.info('试用期结束，请购买正式会员');
                return false;
            }
            // 会员未过期，可以继续
            return true;
        }
        
        // 其他情况（理论上不应该到达这里）
        message.info('完整学习体验需要会员权限支持哦！');
        return false;
    }

    const handleBack = () => {
        if (fromYingshi) {
            const slide = yingshiSlide != null ? yingshiSlide : getYingshiSlideIndex(yingshiSerialId);
            navigate(`/yingshi?slide=${slide}`);
            return;
        }
        else navigate(`/home?type=${type}`);
    };

    const openMusic = () => {
        let value = localStorage.getItem('music');
        if (value !== null && value !== undefined) {
            try {
                value = JSON.parse(value);
                setMusicStatus(!value);
                localStorage.setItem('music', !value);
                window.dispatchEvent(new CustomEvent('home-music-toggle'));
            } catch (err) {
                console.log(err, 'err');
            }
        }
    };

    // 字体缩放逻辑
    const calcFontSize = (number) => {
        if (1 <= number && number < 10) {
            return '6rem'
        } else if (10 <= number && number < 100) {
            return '5.1rem'
        } else if (100 <= number && number < 1000) {
            return '4rem'
        } else if (number >= 1000) {
            return '4rem'
        }
    }

    // 缓存默认对象，避免重复创建
    const defaultRewardItem = useMemo(() => ({ number: 1 }), []);
    
    const fillArray = useCallback((originalArray) => {
        const id = Number(currentSerialId);
        const tmp = (originalArray || []).filter(item => Number(item.serial_id) === id);
        // 使用 Map：key 统一为 Number(number)，避免 JSON 导致 string 与 number 比较失败（尤其 31 关后）
        const rewardMap = new Map(tmp.map(item => [Number(item.number), item]));
        const maxNumber = MAX_LEVEL;
        const filledArray = new Array(maxNumber);
        
        for (let i = 1; i <= maxNumber; i++) {
            // 仅第4关前置到第3关：前30关为3、8、12、16、20、24、28
            const isBoxLevel = i <= 30 ? (i === 3 || (i >= 8 && i % 4 === 0)) : (i % 6 === 0);
            if (isBoxLevel && rewardMap.has(i)) {
                filledArray[i - 1] = rewardMap.get(i);
            } else {
                filledArray[i - 1] = defaultRewardItem;
            }
        }
        return filledArray;
    }, [currentSerialId, defaultRewardItem]);

    function fillBig(originalArray) {
        const id = Number(currentSerialId);
        const tmp = (originalArray || []).filter(item => Number(item.serial_id) === id);
        return tmp.length !== 0;
    }

    /** 合并多页奖励列表并按 (serial_id, number) 去重。不依赖后端 serial 筛选，前端自过滤。 */
    const mergeRewardPages = useCallback((...lists) => {
        const seen = new Map();
        for (const list of lists) {
            for (const item of list || []) {
                const sid = Number(item.serial_id);
                const num = Number(item.number);
                const key = `${sid}-${num}`;
                if (!seen.has(key)) seen.set(key, item);
            }
        }
        return [...seen.values()];
    }, []);

    useEffect(() => {
        try {
            const raw = localStorage.getItem('music');
            if (raw !== null && raw !== undefined) {
                const v = JSON.parse(raw);
                setMusicStatus(!!v);
            }
        } catch (e) {}
    }, []);

    // 家长学前须知弹窗：打开时播放语音，14 秒或播放结束后才允许点击「开始学习」；打开时暂停页面背景音乐
    useEffect(() => {
        if (parentPreNoticeVisible) window.dispatchEvent(new CustomEvent('home-bgm-pause'));
    }, [parentPreNoticeVisible]);

    useEffect(() => {
        if (!parentPreNoticeVisible) return;
        const audioEl = parentPreNoticeAudioRef.current;
        if (!audioEl) return;
        const markDone = () => {
            setParentPreNoticeBtnEnabled(true);
            setParentPreNoticeSeen(); // 兜底：听完了就算完成，写 localStorage，弹窗不显示时下次进也不会再卡
        };
        const fallbackTimer = setTimeout(markDone, 14000);
        audioEl.play().catch(markDone);
        audioEl.addEventListener('ended', markDone);
        return () => {
            clearTimeout(fallbackTimer);
            audioEl.removeEventListener('ended', markDone);
        };
    }, [parentPreNoticeVisible]);

    // 家长学前须知弹窗：按钮旁倒计时（数字+秒），总长 14 秒，每秒减 1，到 0 后不再显示
    useEffect(() => {
        if (!parentPreNoticeVisible) return;
        parentPreNoticeTickRef.current = setInterval(() => {
            setParentPreNoticeCountdown((c) => (c <= 1 ? 0 : c - 1));
        }, 1000);
        return () => {
            if (parentPreNoticeTickRef.current) {
                clearInterval(parentPreNoticeTickRef.current);
                parentPreNoticeTickRef.current = null;
            }
        };
    }, [parentPreNoticeVisible]);

    // 读经小士家长学前须知：打开时暂停背景音乐
    useEffect(() => {
        if (yingshiDujingPreNoticeVisible) window.dispatchEvent(new CustomEvent('home-bgm-pause'));
    }, [yingshiDujingPreNoticeVisible]);
    // 读经小士家长学前须知：语音 9 秒或结束后才允许点击「开始学习」；听完了即写 localStorage 兜底
    useEffect(() => {
        if (!yingshiDujingPreNoticeVisible) return;
        const audioEl = yingshiDujingPreNoticeAudioRef.current;
        if (!audioEl) return;
        const markDone = () => {
            setYingshiDujingPreNoticeBtnEnabled(true);
            setYingshiDujingPreNoticeSeen(); // 兜底：听完了就算完成
        };
        const fallbackTimer = setTimeout(markDone, 9000);
        audioEl.play().catch(markDone);
        audioEl.addEventListener('ended', markDone);
        return () => {
            clearTimeout(fallbackTimer);
            audioEl.removeEventListener('ended', markDone);
        };
    }, [yingshiDujingPreNoticeVisible]);
    // 读经小士家长学前须知：按钮旁 9 秒倒计时
    useEffect(() => {
        if (!yingshiDujingPreNoticeVisible) return;
        yingshiDujingPreNoticeTickRef.current = setInterval(() => {
            setYingshiDujingPreNoticeCountdown((c) => (c <= 1 ? 0 : c - 1));
        }, 1000);
        return () => {
            if (yingshiDujingPreNoticeTickRef.current) {
                clearInterval(yingshiDujingPreNoticeTickRef.current);
                yingshiDujingPreNoticeTickRef.current = null;
            }
        };
    }, [yingshiDujingPreNoticeVisible]);

    useEffect(() => {
        const abortController = new AbortController();
        const signal = abortController.signal;

        const fetchWithAbort = (promiseFn, params) => {
            return promiseFn({ ...params, signal }).catch(err => {
                if (err.name !== 'AbortError') throw err;
            });
        };

        const fetchData = async () => {
            try {
                const sid = currentSerialId;
                if (sid == null || sid === undefined) return;
                // 一批并行：基础数据 + 宠物 + 宝箱状态（不依赖 getCourseMenu / 后端 serial 接口）
                const [
                    serialRes,
                    studyRes,
                    userRes,
                    gardenRes,
                    r2p1,
                    r2p2,
                    r3p1,
                    r3p2
                ] = await Promise.all([
                    fetchWithAbort(getCourseSerial, { serial_id: sid }),
                    fetchWithAbort(getStudyRecord, { serial_id: sid, page: 1, size: 500 }),
                    fetchWithAbort(getUserInfo, {}),
                    fetchWithAbort(getGardenInfo, {}),
                    fetchWithAbort(getStorRewadRecord, { type: 2, page: 1, size: 500 }),
                    fetchWithAbort(getStorRewadRecord, { type: 2, page: 2, size: 500 }),
                    fetchWithAbort(getStorRewadRecord, { type: 3, page: 1, size: 500 }),
                    fetchWithAbort(getStorRewadRecord, { type: 3, page: 2, size: 500 })
                ]);

                if (signal.aborted) return;

                if (serialRes?.data?.serial) {
                    const s = serialRes.data.serial;
                    const curr = Math.min(Number(s?.curr_step || 0), MAX_LEVEL);
                    setCount(curr);
                    setAvatarStatus(true);
                    setId(s?.serial_id);
                    setProgress(curr / MAX_LEVEL);
                    setToal(MAX_LEVEL);

                    // demo 模式：强制只展示前三关，并从 0% 开始显示进度
                    if (demoMode) {
                        const DEMO_MAX_LEVEL = 3;
                        setCount(DEMO_MAX_LEVEL);
                        setAvatarStatus(true);
                        setProgress(0);
                        setToal(DEMO_MAX_LEVEL);
                    }
                }
                if (studyRes?.data) setRecordList(studyRes.data?.study_list || []);
                if (userRes?.data) {
                    setUser(userRes.data || {});
                    const vipMessages = {
                        1: '试用期结束，请购买正式会员',
                        2: `很抱歉,非会员只能体验前${MAX_LEVEL}关卡`,
                        3: '完整学习体验需要会员权限支持哦！',
                        4: '后续关卡正在维护中，敬请期待',
                        5: DAILY_LEVEL_LIMIT_MESSAGE,
                        6: DAILY_LEVEL_LIMIT_MESSAGE
                    };
                    if (vip in vipMessages) message.info(vipMessages[vip]);
                }

                const petData = gardenRes?.data?.garden_info ? { garden_info: gardenRes.data.garden_info } : {};
                setPet(petData);
                if (petData?.garden_info) savePetInfoToStorage(petData);

                const list2 = mergeRewardPages(
                    r2p1?.data?.reward_list || [],
                    r2p2?.data?.reward_list || []
                );
                const list3 = mergeRewardPages(
                    r3p1?.data?.reward_list || [],
                    r3p2?.data?.reward_list || []
                );
                setRewordList(fillArray(list2) || []);
                setIsOpeBig(fillBig(list3));
            } catch (e) {
                if (!signal.aborted) {
                    console.error('请求失败:', e);
                    message.error('数据加载失败，请重试');
                }
            }
        };

        fetchData();
        return () => abortController.abort();
    }, [currentSerialId, mergeRewardPages, fillArray]);

    // 计算每个关卡的像素高度
    const itemHeightPx = ITEM_HEIGHT_REM * rootFontSize;
    
    // 礼物盒高度（300px + 一些间距）
    const giftBoxHeight = 300;
    
    // 计算总高度（礼物盒 + 所有关卡）
    const totalHeight = giftBoxHeight + total * itemHeightPx;
    
    // 虚拟列表：计算可见范围内的关卡
    const visibleRange = useMemo(() => {
        // 减去礼物盒高度后的滚动位置
        const adjustedScrollTop = Math.max(0, scrollTop - giftBoxHeight);
        const startIdx = Math.floor(adjustedScrollTop / itemHeightPx);
        const endIdx = Math.min(
            total - 1,
            Math.ceil((adjustedScrollTop + containerHeight) / itemHeightPx)
        );
        
        // 添加缓冲区
        const bufferedStart = Math.max(0, startIdx - BUFFER_SIZE);
        const bufferedEnd = Math.min(total - 1, endIdx + BUFFER_SIZE);
        
        return { start: bufferedStart, end: bufferedEnd };
    }, [scrollTop, containerHeight, itemHeightPx, total, giftBoxHeight]);
    
    // 生成可见的关卡列表
    const visibleLevels = useMemo(() => {
        const levels = [];
        for (let idx = visibleRange.start; idx <= visibleRange.end; idx++) {
            // i 是实际关卡编号（从 total 倒序）
            const i = total - idx - 1;
            levels.push({ idx, i, level: i + 1 });
        }
        return levels;
    }, [visibleRange, total]);
    
    // 处理滚动事件 - 使用 requestAnimationFrame 节流
    const rafRef = useRef(null);
    const handleScroll = useCallback((e) => {
        const newScrollTop = e.target.scrollTop;
        if (rafRef.current) {
            cancelAnimationFrame(rafRef.current);
        }
        rafRef.current = requestAnimationFrame(() => {
            setScrollTop(newScrollTop);
        });
    }, []);
    
    // 计算滚动百分比（用于滚动条）
    const scrollPercentage = useMemo(() => {
        const maxScroll = totalHeight - containerHeight;
        if (maxScroll <= 0) return 0;
        return Math.min(1, Math.max(0, scrollTop / maxScroll));
    }, [scrollTop, totalHeight, containerHeight]);
    
    // 滚动条滑块高度 - 固定圆形滑块大小
    const thumbHeight = 28;
    
    // 滚动条：处理点击轨道
    const handleScrollbarClick = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.target === thumbRef.current) return; // 点击滑块不处理
        
        const rect = scrollbarRef.current.getBoundingClientRect();
        const clickY = e.clientY - rect.top;
        const trackHeight = rect.height;
        const percentage = clickY / trackHeight;
        
        const maxScroll = totalHeight - containerHeight;
        const newScrollTop = percentage * maxScroll;
        
        if (buttonContainerRef.current) {
            buttonContainerRef.current.scrollTop = newScrollTop;
            setScrollTop(newScrollTop);
        }
    }, [totalHeight, containerHeight]);
    
    // 滚动条：处理拖动滑块（优化：降低拖动速度，减少内存占用）
    const handleThumbMouseDown = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(true);
        
        const startY = e.clientY;
        const startScrollTop = scrollTop;
        const trackHeight = scrollbarRef.current.getBoundingClientRect().height - thumbHeight;
        const maxScroll = totalHeight - containerHeight;
        
        let lastUpdateTime = 0;
        const throttleDelay = 16; // 约60fps，降低更新频率
        
        const handleMouseMove = (moveEvent) => {
            moveEvent.preventDefault();
            const now = Date.now();
            
            // 节流：限制更新频率
            if (now - lastUpdateTime < throttleDelay) {
                return;
            }
            lastUpdateTime = now;
            
            const deltaY = moveEvent.clientY - startY;
            // 降低拖动速度：乘以0.6，让拖动更慢更平滑
            const deltaScroll = (deltaY / trackHeight) * maxScroll * 0.6;
            const newScrollTop = Math.min(maxScroll, Math.max(0, startScrollTop + deltaScroll));
            
            if (buttonContainerRef.current) {
                buttonContainerRef.current.scrollTop = newScrollTop;
                setScrollTop(newScrollTop);
            }
        };
        
        const handleMouseUp = () => {
            setIsDragging(false);
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
        
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    }, [scrollTop, totalHeight, containerHeight, thumbHeight]);
    
    // 滚动条：处理触摸拖动（移动端，优化：降低拖动速度，减少内存占用）
    const handleThumbTouchStart = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(true);
        
        const startY = e.touches[0].clientY;
        const startScrollTop = scrollTop;
        const trackHeight = scrollbarRef.current.getBoundingClientRect().height - thumbHeight;
        const maxScroll = totalHeight - containerHeight;
        
        let lastUpdateTime = 0;
        const throttleDelay = 16; // 约60fps，降低更新频率
        
        const handleTouchMove = (moveEvent) => {
            moveEvent.preventDefault();
            moveEvent.stopPropagation();
            const now = Date.now();
            
            // 节流：限制更新频率
            if (now - lastUpdateTime < throttleDelay) {
                return;
            }
            lastUpdateTime = now;
            
            const deltaY = moveEvent.touches[0].clientY - startY;
            // 降低拖动速度：乘以0.6，让拖动更慢更平滑
            const deltaScroll = (deltaY / trackHeight) * maxScroll * 0.6;
            const newScrollTop = Math.min(maxScroll, Math.max(0, startScrollTop + deltaScroll));
            
            if (buttonContainerRef.current) {
                buttonContainerRef.current.scrollTop = newScrollTop;
                setScrollTop(newScrollTop);
            }
        };
        
        const handleTouchEnd = () => {
            setIsDragging(false);
            document.removeEventListener('touchmove', handleTouchMove);
            document.removeEventListener('touchend', handleTouchEnd);
        };
        
        document.addEventListener('touchmove', handleTouchMove, { passive: false });
        document.addEventListener('touchend', handleTouchEnd);
    }, [scrollTop, totalHeight, containerHeight, thumbHeight]);

    useEffect(() => {
        // 滚动至当前关卡，并让其居中显示
        const currentLevelTop = giftBoxHeight + (total - count) * itemHeightPx;
        // 计算让当前关卡居中的滚动位置（减去半个屏幕高度，再加上关卡元素的一半高度）
        const centerOffset = containerHeight / 2 - itemHeightPx / 2;
        const targetScrollTop = Math.max(0, currentLevelTop - centerOffset);
        
        if (buttonContainerRef.current) {
            buttonContainerRef.current.scrollTop = targetScrollTop;
            setScrollTop(targetScrollTop);
        }
    }, [count, itemHeightPx, random, total, giftBoxHeight, containerHeight]);
    
    // 监听容器高度变化
    useEffect(() => {
        const updateContainerHeight = () => {
            setContainerHeight(window.innerHeight);
        };
        window.addEventListener('resize', updateContainerHeight);
        return () => {
            window.removeEventListener('resize', updateContainerHeight);
            if (rafRef.current) {
                cancelAnimationFrame(rafRef.current);
            }
        };
    }, []);

    useEffect(() => {
        // 获取 rootFontSize 和屏幕宽度
        const handleResize = () => {
            setRootFontSize(parseFloat(getComputedStyle(document.documentElement).fontSize));
            setScreenWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const loadScores = async () => {
            try {
                // 使用 [...recordList].reverse() 避免修改原数组
                const reversedList = [...recordList].reverse();
                const filledScores = [...reversedList, ...Array(total - recordList.length).fill({ score: 0 })];
                setScores(filledScores.slice(0, total));
            } catch (error) {
                console.error('Failed to fetch scores:', error);
                setScores(Array(total).fill({ score: 0 }));
            }
        };

        loadScores();
    }, [total, recordList]);

    useEffect(() => {
        // 检查当前关卡是否在视口内，并更新返回按钮的显示状态
        const currentTargetScrollTop = giftBoxHeight + (total - count) * itemHeightPx;
        const threshold = window.innerHeight;
        setIsback(Math.abs(scrollTop - currentTargetScrollTop) > threshold);
    }, [scrollTop, count, total, itemHeightPx, giftBoxHeight]);

    // 背景索引（用于CSS类名）；影视入口用 bk13/bk14/bk15 对应第1/2/3页背景
    const backgroundIndex = () => {
        if (fromYingshi && yingshiSerialId) {
            const slideIdx = getYingshiSlideIndex(yingshiSerialId);
            return 13 + slideIdx; // bk13=第1页, bk14=第2页, bk15=第3页
        }
        if (type == 0 && index == 0) return 1;
        if (type == 0 && index == 1) return 2;
        if (type == 0 && index == 2) return 3;
        if (type == 0 && index == 3) return 4;
        if (type == 1 && index == 0) return 5;
        if (type == 1 && index == 1) return 6;
        if (type == 1 && index == 2) return 7;
        if (type == 1 && index == 3) return 8;
        if (type == 2 && index == 0) return 9;
        if (type == 2 && index == 1) return 10;
        if (type == 2 && index == 2) return 11;
        if (type == 2 && index == 3) return 12;
        return 1;
    }

    const gotoback = () => {
        setRandom(Math.random())
    }
    
    // 背景图状态 - 动态加载（带 webp 降级）；影视入口复用 0-0 图，避免多占资源
    const [backImage, setBackImage] = useState(null);
    
    useEffect(() => {
        // 影视入口背景由 CSS bk13/bk14/bk15 提供，无需动态加载
        if (fromYingshi) return;
        const key = `${type}-${index}`;
        let isMounted = true;
        
        const loadBackground = async () => {
            await checkWebpSupport();
            const webpSupported = isWebpSupported();
            
            const paths = webpSupported ? backgroundPathsWebp : backgroundPathsPng;
            const loader = paths[key] || paths['0-0'];
            
            try {
                const module = await loader();
                if (isMounted) {
                    setBackImage(module.default);
                }
            } catch (err) {
                console.error('背景图加载失败:', err);
                if (webpSupported) {
                    try {
                        const fallbackLoader = backgroundPathsPng[key] || backgroundPathsPng['0-0'];
                        const fallback = await fallbackLoader();
                        if (isMounted) {
                            setBackImage(fallback.default);
                        }
                    } catch (e) {
                        console.error('降级图片也加载失败:', e);
                    }
                }
            }
        };
        
        loadBackground();
        
        return () => {
            isMounted = false;
        };
    }, [type, index, fromYingshi]);
    const avator = [menu1_avator, menu2_avator, menu3_avator];
    const getBigNumber = (serialOrType) => {
        switch (serialOrType) {
            case 7:
                return 250
            case 10:
                return 450
            case 11:
                return 550
            case 12:
                return 650
            case 13:
                return 880
            case 14:
                return 980
            case 15:
                return 1200
            case 20:
                return 1300
            case 21:
                return 1450
            case 22:
                return 1550
            case 23:
                return 1750
            case 24:
                return 2100;
            default:
                return 250;
        }
    }
    const dispatch = useDispatch();
    const getGift = () => {
        if (isOpeBig) {
            message.info('已领取过终极大礼');
            return;
        }
        const searchParams = new URLSearchParams(location.search);
        const testBigBox = searchParams.get('testBigBox') === '1';
        if (!testBigBox && count < MAX_LEVEL) {
            message.info(`通关${MAX_LEVEL}关后可领取终极大礼`);
            return;
        }
        const bigCoin = getBigBoxCoin(pet);
        setCoin(bigCoin);
        setBoxFood(null); // 大宝箱仅金币，不展示食物
        playTreasureBoxOpenSound();
        if (audioOpenLiwuMusic.current) {
            audioOpenLiwuMusic.current.play().catch(() => {});
        }
        studyDoneReward({
            serial_id: currentSerialId,
            number: MAX_LEVEL,
            coin: bigCoin,
            type: 3
        }).then((res) => {
            if (res?.code !== 0) {
                message.info(res?.message || '领取失败，请重试');
                return;
            }
            setIsOpeBig(true);
            setBoxVisible(true);
            getUserInfo({}).then((r) => {
                if (r?.data) dispatch(setUserAction(r.data));
            }).catch(() => {});
            Promise.all([
                getStorRewadRecord({ type: 3, page: 1, size: 500 }),
                getStorRewadRecord({ type: 3, page: 2, size: 500 })
            ]).then(([r1, r2]) => {
                const list3 = mergeRewardPages(
                    r1?.data?.reward_list || [],
                    r2?.data?.reward_list || []
                );
                setIsOpeBig(fillBig(list3));
            });
        }).catch((err) => {
            message.info(err?.response?.data?.message || err?.message || '领取失败，请重试');
        });
    };


    useEffect(() => {
        let timeoutId = setTimeout(() => {
            setMusk(false)
        }, 800);

        return () => {
            clearTimeout(timeoutId);
        };
    }, []);

    // 组件卸载时清理音频资源
    useEffect(() => {
        return () => {
            // 清理音频
            if (audioOpenLiwuMusic.current) {
                audioOpenLiwuMusic.current.pause();
                audioOpenLiwuMusic.current.src = '';
                audioOpenLiwuMusic.current.load();
            }
            // 清理背景图引用
            setBackImage(null);
            // 清理 antd message
            message.destroy();
        };
    }, []);

    const boxOk = () => {
        setBoxVisible(false);
    }

    const boxFeedOk = () => {
        setBoxVisible(false);
        navigate('/pet');
    }

    // P0优化：获取当前悟空头像
    const getCurrentPetAvatar = useCallback(() => {
        return getPetAvatarSrc(pet?.garden_info?.PetInfo?.Phase);
    }, [pet]);

    // 使用公共组件 - 与 Detail 保持一致，支持 30% 食物展示
    const boxContent = useMemo(() => (
        <TreasureBoxModal coin={coin} food={boxFood} />
    ), [coin, boxFood]);

    const openLiwuFn = () => {
        setBoxVisible(true)
    }

    // 使用与Detail页面一致的金币计算逻辑
    const getRandomWeightedNumber = useCallback(() => {
        return getTreasureBoxCoin(pet);
    }, [pet]);
    const cls = `level-background bk${backgroundIndex()}`
    const audioSrcList = [`${OssOther}/music/first.mp3`, `${OssOther}/music/two.mp3`, `${OssOther}/music/three.mp3`]
    return (
        <div>
            <div className={cls}>
                <div className='level-container level-container-virtual' ref={buttonContainerRef} onScroll={handleScroll}>
                    {/* 虚拟列表：总高度占位 */}
                    <div style={{ height: totalHeight, position: 'relative' }}>
                        {/* 礼物盒 - 固定在顶部，屏幕居中 */}
                        <div 
                            className={isOpeBig ? 'liwuopen' : 'liwu'} 
                            onClick={getGift}
                            style={{ 
                                position: 'absolute', 
                                top: 0,
                                // 礼物盒居中于屏幕
                                left: (screenWidth - 300) / 2
                            }}
                        >
                            <img src={isOpeBig ? openLiwu : unopenLiwu} />
                        </div>
                        
                        {/* 虚拟列表：只渲染可见的关卡 */}
                        {visibleLevels.map(({ idx, i, level }) => {
                            // 计算该关卡的 top 位置（礼物盒高度 + 关卡偏移）
                            const top = giftBoxHeight + idx * itemHeightPx;
                            // 计算 margin-left（基于显示索引，从1开始）
                            const displayIndex = idx + 1;
                            const marginLeft = getMarginLeft(displayIndex, screenWidth);
                            
                            return (
                                <div 
                                    key={i} 
                                    className="level-content level-virtual"
                                    style={{
                                        position: 'absolute',
                                        top: top,
                                        left: marginLeft,
                                    }}
                                >
                                    <div className="level-item" onClick={() => gotoDetail(level)}>
                                        {/* 是否是头像 */}
                                        {/* 仅第4关前置到第3关：前30关3、8、12、16、20、24、28 */}
                                        <div className={((level <= 30 && (level === 3 || (level >= 8 && level % 4 === 0))) || (level > 30 && level % 6 === 0)) ? 'img1' : 'img'}>
                                            {count === level ? (
                                                avatarStatus ? (
                                                    <div className='avator-ss'>
                                                        <img className='avator' src={avator[fromYingshi ? 0 : type] ?? avator[0]} />
                                                    </div>
                                                ) : (
                                                    <img src={step} />
                                                )
                                            ) : (
                                                /* 仅第4关前置到第3关：前30关3、8、12、16、20、24、28 */
                                                ((level <= 30 && (level === 3 || (level >= 8 && level % 4 === 0))) || (level > 30 && level % 6 === 0)) ? (
                                                    <img 
                                                        src={(rewordList[i] && Number(rewordList[i].serial_id) === Number(currentSerialId)) && avatarStatus ? openLiwu : unopenLiwu} 
                                                        className={
                                                            (rewordList[i] && Number(rewordList[i].serial_id) === Number(currentSerialId)) && avatarStatus 
                                                                ? 'open' 
                                                                : level <= count 
                                                                    ? 'unopen unopen-ready' // 已闯关但未打开 - 添加提示动画
                                                                    : 'unopen'
                                                        } 
                                                    />
                                                ) : (
                                                    level > count ? (
                                                        <img className='unstep' src={unstep} />
                                                    ) : (
                                                        // 已完成的关卡 - 添加金色光环
                                                        <img className='completed' src={step} />
                                                    )
                                                )
                                            )}
                                        </div>
                                        {(count === level && avatarStatus) || ((level <= 30 && (level === 3 || (level >= 8 && level % 4 === 0))) || (level > 30 && level % 6 === 0)) ? (
                                            <div className={((level <= 30 && (level === 3 || (level >= 8 && level % 4 === 0))) || (level > 30 && level % 6 === 0)) ? 'opennumber' : 'unnumber'}></div>
                                        ) : (
                                            // 未解锁用灰色数字，已完成用正常数字
                                            <div 
                                                className={level > count ? "number-locked" : "number"} 
                                                style={{ fontSize: calcFontSize(i) }}
                                            >
                                                {level}
                                            </div>
                                        )}
                                    </div>
                                    <div className={level > count ? "star-locked" : "star"}>
                                        {Array.from({ length: 3 }, (_i, j) => (
                                            <div className='star-item' key={j}>
                                                {j < scores[i]?.score ? <img src={star} /> : <img src={unstar} />}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
            {/* <div className='menu-slider' >
                <VerticalSlider onChange={handleChange} initialValue={100} min={0} max={100} level={scrollPercentage} />
            </div> */}
            {/* {
                musicStatus ? <img src={music} className='menu-music' onClick={openMusic} />
                    :
                    <img src={musicClose} className='menu-music' onClick={openMusic} />
            } */}
            <div className='menu-progress'>
                <div className='title'>{serialName(id)}</div>
                <div className='progress-item'>
                    <div className='progress-content' style={{ width: `${Math.max(progress * 100, 8)}%` }}></div>
                    <div className='number'>{Math.min(count, total)}/{total}</div>
                </div>
            </div>
            {musk ? <Loadding pet={pet} /> : null}
            {Isback ? <div className='back' onClick={gotoback}>返回</div> : null}
            <img src={back} className='menu-back' onClick={handleBack} />
            
            {/* 左下角垂直滚动条 */}
            <div 
                className={`custom-scrollbar ${isDragging ? 'dragging' : ''}`}
                ref={scrollbarRef}
                onClick={handleScrollbarClick}
                onTouchStart={(e) => e.stopPropagation()}
            >
                <div className="scrollbar-track">
                    <div 
                        className="scrollbar-thumb"
                        ref={thumbRef}
                        style={{
                            top: `calc(${scrollPercentage * 100}% - ${scrollPercentage * thumbHeight}px)`,
                        }}
                        onMouseDown={handleThumbMouseDown}
                        onTouchStart={handleThumbTouchStart}
                    >
                        <div className="thumb-indicator">
                            <span>{Math.round((1 - scrollPercentage) * total) || 1}</span>
                        </div>
                    </div>
                </div>
            </div>
            {/*  <div className='menu-bakcground'><img src={backImage} /></div> */}
            {/* 家长学前须知：用 portal 自绘弹窗，避免部分平板 Ant Design Modal 不显示 */}
            {parentPreNoticeVisible && (
                <audio ref={parentPreNoticeAudioRef} src={tipsAudioSrc} preload="auto" />
            )}
            {parentPreNoticeVisible && createPortal(
                <div className="menu-parent-pre-notice-custom">
                    <div className="menu-parent-pre-notice-custom-mask" aria-hidden />
                    <div className="menu-parent-pre-notice-custom-box">
                        <div className="menu-parent-pre-notice-custom-header">
                            <span className="menu-parent-pre-notice-custom-title">家长学前须知</span>
                            <button
                                type="button"
                                className="menu-parent-pre-notice-custom-close"
                                onClick={() => {
                                    parentPreNoticeAudioRef.current?.pause();
                                    setParentPreNoticeSeen();
                                    setParentPreNoticeVisible(false);
                                    window.dispatchEvent(new CustomEvent('home-bgm-resume'));
                                }}
                                aria-label="关闭"
                            >
                                ×
                            </button>
                        </div>
                        <div className="menu-parent-pre-notice-content">
                            <div className="icon icon--smile"><img src={silme} alt="笑脸" loading="lazy" /></div>
                            <p>1、不要强迫跟读，输入够了<span className="highlight">自然会读</span>。</p>
                            <p>2、不要纠正发音，听多了<span className="highlight">自然就地道</span>。</p>
                            <p>3、不要帮小朋友查英文词典解释意思，沉浸式母语环境，<span className="highlight">右脑图像思维学习力</span>最强。</p>
                        </div>
                        <div className="menu-parent-pre-notice-custom-footer">
                            <Button
                                type="primary"
                                className="menu-parent-pre-notice-btn"
                                onClick={() => {
                                    if (!handlePermission(parentPreNoticeTargetLevel)) return;
                                    setParentPreNoticeSeen();
                                    const rewardItem = rewordList[parentPreNoticeTargetLevel - 1];
                                    const boxOpened = rewardItem && Number(rewardItem.serial_id) === Number(currentSerialId);
                                    setParentPreNoticeVisible(false);
                                    const detailQuery = fromYingshi
                                        ? `from=yingshi&serial_id=${currentSerialId}&level=${parentPreNoticeTargetLevel}&maxLevel=${count}&boxOpened=${boxOpened ? '1' : '0'}`
                                        : `type=${type}&index=${index}&level=${parentPreNoticeTargetLevel}&maxLevel=${count}&boxOpened=${boxOpened ? '1' : '0'}`;
                                    navigate(`/detail?${detailQuery}`);
                                }}
                                disabled={!parentPreNoticeBtnEnabled}
                            >
                                {parentPreNoticeCountdown > 0 ? `开始学习（${parentPreNoticeCountdown}秒）` : '开始学习'}
                            </Button>
                        </div>
                    </div>
                </div>,
                document.body
            )}
            {/* 读经小士(985)家长学前须知：同上用 portal 自绘弹窗 */}
            {yingshiDujingPreNoticeVisible && (
                <audio ref={yingshiDujingPreNoticeAudioRef} src={tips2AudioSrc} preload="auto" />
            )}
            {yingshiDujingPreNoticeVisible && createPortal(
                <div className="menu-parent-pre-notice-custom menu-yingshi-dujing-pre-notice">
                    <div className="menu-parent-pre-notice-custom-mask" aria-hidden />
                    <div className="menu-parent-pre-notice-custom-box">
                        <div className="menu-parent-pre-notice-custom-header">
                            <span className="menu-parent-pre-notice-custom-title">读经小士 · 家长学前须知</span>
                            <button
                                type="button"
                                className="menu-parent-pre-notice-custom-close"
                                onClick={() => {
                                    yingshiDujingPreNoticeAudioRef.current?.pause();
                                    setYingshiDujingPreNoticeVisible(false);
                                    window.dispatchEvent(new CustomEvent('home-bgm-resume'));
                                }}
                                aria-label="关闭"
                            >
                                ×
                            </button>
                        </div>
                        <div className="menu-parent-pre-notice-content">
                            <div className="icon icon--smile"><img src={silme} alt="笑脸" loading="lazy" /></div>
                            <p>雷音寺里藏着的都是中高考高频考点，难度有点挑战，请家长和小朋友一起加油努力哦～</p>
                        </div>
                        <div className="menu-parent-pre-notice-custom-footer">
                            <Button
                                type="primary"
                                className="menu-parent-pre-notice-btn"
                                onClick={() => {
                                    if (!handlePermission(1)) return;
                                    setYingshiDujingPreNoticeSeen();
                                    setYingshiDujingPreNoticeVisible(false);
                                    const boxOpened = rewordList[0] && Number(rewordList[0].serial_id) === Number(currentSerialId);
                                    navigate(`/detail?from=yingshi&serial_id=${currentSerialId}&level=1&maxLevel=${count}&boxOpened=${boxOpened ? '1' : '0'}`);
                                }}
                                disabled={!yingshiDujingPreNoticeBtnEnabled}
                            >
                                {yingshiDujingPreNoticeCountdown > 0 ? `开始学习（${yingshiDujingPreNoticeCountdown}秒）` : '开始学习'}
                            </Button>
                        </div>
                    </div>
                </div>,
                document.body
            )}
            {/* 全屏烟花效果 */}
            <Fireworks visible={boxVisible} duration={3000} />
            <WkModal
                visible={boxVisible}
                onOk={boxOk}
                onCancel={boxOk}
                onBtn={boxFeedOk}
                onBtnVisable={true}
                isGuide={true}
                tongquStyle
                cancelText={'去升级悟空'}
                content={boxContent}
                okText={'确定'}
            />
            {/* <audio ref={audioRef} src={audioSrcList[type]} controls className='menu-audio' /> */}
            <audio ref={audioOpenLiwuMusic} src={openLiwuMusic} controls className='menu-audio' />
        </div >
    );
};

export default Menu; 
